import React from 'react'
import SupplementSection from '../../Various/SupplementSection/SupplementSection'
import { Col, Container, Row } from '@headtrip/components-react'
import * as PropTypes from 'prop-types'

const linkList = [
  {
    title: 'Legal notice',
    url: 'https://www.hetzner.com/rechtliches/impressum'
  },
  {
    title: 'Data privacy',
    url: 'https://www.hetzner.com/rechtliches/datenschutz'
  },
  {
    title: 'System policies',
    url: 'https://www.hetzner.com/rechtliches/system-policies'
  },
  {
    title: 'Terms and conditions',
    url: 'https://www.hetzner.com/rechtliches/agb'
  }
]

function FooterLink ({ link, text }) {
  return (
    <li className='list-inline-item m-0 px-1 font-weight-bold'>
      <a
        href={link}
        className='text-white'
        target='_blank'
      >
        {text}
      </a>
    </li>)
}

function setCopyrightYear () {
  return new Date().getFullYear()
}

function Footer (props) {
  const supplementColor = props.supplementColor || 'light-grey'

  return (
    <footer className='bg-black'>
      <section className='bg-red'>
        <Container>
          <SupplementSection color={supplementColor} />
        </Container>
      </section>
      <div className='pt-4 pb-3 bg-black text-white'>
        <Container>
          <Row>
            <Col sm={12} md={12} lg={12} xl={12} className='text-center'>
              <span>
              © {setCopyrightYear()}. Hetzner Online GmbH. All Rights Reserved.
              </span>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} xl={12}>
              <ul className='list-unstyled list-inline text-center text-lg-center m-0 footer-links-list'>
                {
                  linkList.map((link, index) => {
                    return (
                      <FooterLink
                        key={`footer-link-${index}`}
                        link={link.url}
                        text={link.title}
                        isSmall
                      />
                    )
                  })
                }
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  color: PropTypes.string.isRequired
}

export default Footer
